module.exports = __webpack_public_path__ + "img/buenos-aires.81186d62.jpg";